const normalizePhone = (value: string): string => {
  return value.replace(/\D/g, "");
};

export const isValidCPF = (cpf: string): boolean => {
  // Remove caracteres não numéricos
  cpf = cpf.replace(/[^\d]+/g, "");

  if (cpf.length !== 11) return false;

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(cpf)) return false;

  let sum = 0;
  let remainder;

  // Valida primeiro dígito verificador
  for (let i = 1; i <= 9; i++) {
    sum += parseInt(cpf[i - 1]) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf[9])) return false;

  // Valida segundo dígito verificador
  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(cpf[i - 1]) * (12 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf[10])) return false;

  return true;
};

export const isValidWhatsAppBR = (value: string): boolean => {
  if (!value) return false;

  // ❌ não permite +, letras ou símbolos
  if (!/^\d+$/.test(value)) return false;

  /*
    Brasil:
    55 + DDD (2 dígitos de 1 a 9)
    + (9 + 8 dígitos) OU (8 dígitos)
  */
  return /^55[1-9]{2}(9\d{8}|\d{8})$/.test(value);
};

// export const isValidWhatsAppBR = (value: string): boolean => {
//   if (!value) return false;

//   // ❌ não permite +, letras ou símbolos
//   if (!/^\d+$/.test(value)) return false;

//   // Brasil: 55 + DDD + 9 + 8 dígitos
//   return /^55[1-9]{2}9[0-9]{8}$/.test(value);
// };

export const isValidFullName = (value: string): boolean => {
  if (!value) return false;

  return true;

  const parts = value.trim().split(/\s+/);

  if (parts.length < 2) return false;

  const nameRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ]+$/;
  const particles = ["de", "da", "do", "dos", "das"];

  // valida todas as partes (letras apenas)
  for (const part of parts) {
    if (!nameRegex.test(part)) return false;
  }

  const lastName = parts[parts.length - 1];

  // sobrenome final precisa ter no mínimo 4 letras
  if (lastName.length < 4) return false;

  // evita terminar com partícula
  if (particles.includes(lastName.toLowerCase())) return false;

  return true;
};
